import type { OutreachSourceType } from "features/integrations/types";

import FileInfo from "./FileInfo";
import UrlColumnSelect from "./UrlColumnSelect";
import VariablesTable from "./VariablesTable";

import type { CsvState } from "../../../types";

interface CsvOverviewProps {
  uploadState: { csvState: CsvState; sourceName: string | OutreachSourceType };
  mainIdentifier: string;
  setMainIdentifier: (identifier: string) => void;
  reset: () => void;
}

export default function CsvOverview({
  uploadState,
  mainIdentifier,
  setMainIdentifier,
  reset,
}: CsvOverviewProps) {
  const { csvState } = uploadState;
  const { url_columns, columns, parsed } = csvState;

  const isFileError =
    !csvState ||
    !mainIdentifier ||
    !parsed.length ||
    !columns.every((col) => !!col);

  return (
    <>
      <FileInfo
        uploadState={uploadState}
        isFileError={isFileError}
        resetFile={reset}
      />

      {columns.length > 1 && (
        <>
          <UrlColumnSelect
            options={url_columns}
            urlColumn={mainIdentifier}
            onSelect={(value) => setMainIdentifier(value)}
          />
          <VariablesTable
            variables={columns.filter((column) => column !== mainIdentifier)}
          />
        </>
      )}
    </>
  );
}
